import React from 'react';
import Svg from '../Svg';

import { IconProps } from '../icon';

export const Wallet20 = ({
  accessibilityLabel,
  contrast,
  className,
}: IconProps) => (
  <Svg
    accessibilityLabel={accessibilityLabel}
    size={20}
    contrast={contrast}
    className={className}
  >
    <path d='M13 13.75V11.25H14.5V13.75H13Z' fill='currentColor' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M17.4246 6.25L14.2699 0.992096L12 2.25315V2.25H4C2.48122 2.25 1.25 3.48122 1.25 5V15.5C1.25 17.0188 2.48122 18.25 4 18.25H17.5C18.1904 18.25 18.75 17.6904 18.75 17V6.25H17.4246ZM15.6754 6.25L13.7301 3.00792L7.89436 6.25H15.6754ZM4.80567 6.25L9.30567 3.75H4C3.30964 3.75 2.75 4.30964 2.75 5C2.75 5.69036 3.30964 6.25 4 6.25H4.80567ZM2.75 7.45015V15.5C2.75 16.1904 3.30964 16.75 4 16.75H17.25V7.75H4C3.54989 7.75 3.12503 7.64186 2.75 7.45015Z'
      fill='currentColor'
    />
  </Svg>
);

Wallet20.displayName = 'Wallet20';
export default Wallet20;
